import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M27.879 14.054a.954.954 0 0 0-1.455.704q-.512 4.572-.515 9.66-.004 5.058.496 9.535a.954.954 0 0 0 1.454.704l14.558-9.086a1.43 1.43 0 0 0 0-2.429zm1.012-1.618 14.539 9.087a3.34 3.34 0 0 1-.002 5.667L28.87 36.276a2.863 2.863 0 0 1-4.363-2.111q-.51-4.586-.508-9.748.005-5.192.528-9.872a2.863 2.863 0 0 1 4.364-2.11M6.879 14.054a.955.955 0 0 0-1.454.704q-.513 4.572-.516 9.66-.003 5.058.496 9.535a.954.954 0 0 0 1.454.704l14.558-9.086a1.432 1.432 0 0 0 .001-2.429zm1.012-1.618 14.539 9.087a3.34 3.34 0 0 1-.002 5.667L7.87 36.276a2.864 2.864 0 0 1-4.362-2.111Q2.997 29.579 3 24.417q.003-5.192.528-9.872a2.864 2.864 0 0 1 4.363-2.11",
      clipRule: "evenodd"
    }
  )
);
var SvgFastForwardOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FastForwardOutlined_default = SvgFastForwardOutlined;

export { FastForwardOutlined_default as default };
